import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../services/api';

export default function EventFlowMonitor() {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEventFlow();
  }, []);

  const fetchEventFlow = async () => {
    try {
      const res = await api.get('/admin/event-flow');
      setData(res.data || []);
    } catch (err) {
      console.error('Failed to fetch event flow:', err.response || err);
      setError(err.userMessage || err.response?.data?.message || 'Failed to fetch event flow');
    }
  };

  return (
    <AdminLayout>
      <h2 className="text-xl font-bold mb-4">Event Flow Monitor</h2>
      {error && <p className="text-red-600 mb-4">{error}</p>}
      <table className="w-full bg-white shadow rounded border-collapse">
        <thead>
          <tr className="bg-gray-200 text-left">
            <th className="p-3">Event</th>
            <th className="p-3">Status</th>
            <th className="p-3">Maintenance</th>
            <th className="p-3">Security</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((d, i) => (
              <tr key={i} className="border-b">
                <td className="p-3">{d.eventName}</td>
                <td className="p-3">{d.eventStatus}</td>
                <td className="p-3">{d.maintenanceStatus || 'N/A'}</td>
                <td className="p-3">{d.securityStatus || 'N/A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="p-3 text-center text-gray-500">
                No events found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </AdminLayout>
  );
}
